// extracted by mini-css-extract-plugin
export var dividerContainer = "_93-0";
export var line = "_93-1";